export class CustomersTable {
	public static customers: any = [
		{
			id: 1,
			firstName: 'Sonni',
			lastName: 'Gabotti',
			email: 'sgabotti0@wsj.com',
			userName: 'sgabotti0',
			gender: 'Female',
			status: 0,
			dateOfBbirth: '10/14/1950',
			ipAddress: '',
			type: 1,
			_userId: 1,
			_createdDate: '09/07/2016',
			_updatedDate: '05/31/2013'
		}
	];
}
